module.exports = __webpack_public_path__ + "static/media/signin-modal-alby.772373ef.png";